import { makeVar } from '@apollo/client';

export const updatesCardCountVar = makeVar(0);
